(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-offers-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar=document.querySelector('.zd-offers-bar');
  if(!bar)return;
  var inner=bar.querySelector('.zd-offers-bar__inner');
  bar.querySelectorAll('a[data-zd-anchor]').forEach(function(a){if(!document.getElementById(a.getAttribute('href').slice(1)))a.hidden=true;});
  if(!('IntersectionObserver' in window))return;
  var links=Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]:not([hidden])'));
  if(!links.length)return;
  var map={},current=null;
  links.forEach(function(a){var t=document.getElementById(a.getAttribute('href').slice(1));if(t)map[t.id]=a;});
  function activate(a){
    if(a===current)return;
    if(current)current.classList.remove('is-active');
    a.classList.add('is-active');current=a;
    if(inner.scrollWidth>inner.clientWidth){
      var left=a.offsetLeft-inner.offsetLeft;
      if(left<inner.scrollLeft||left+a.offsetWidth>inner.scrollLeft+inner.clientWidth){inner.scrollLeft=Math.max(0,left-16);}
    }
  }
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting&&map[en.target.id])activate(map[en.target.id]);});},{rootMargin:'-35% 0px -60% 0px'});
  Object.keys(map).forEach(function(id){io.observe(document.getElementById(id));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-offers-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  function rails(sec){return Array.prototype.slice.call(sec.querySelectorAll('.zd-fp__rail'));}
  function sync(sec){var list=rails(sec);if(!list.length)return;var atStart=list.every(function(r){return r.scrollLeft<=4;});var atEnd=list.every(function(r){return r.scrollLeft>=r.scrollWidth-r.clientWidth-4;});var p=sec.querySelector('[data-zd-rail-dir="-1"]');var n=sec.querySelector('[data-zd-rail-dir="1"]');if(p)p.disabled=atStart;if(n)n.disabled=atEnd;}
  function norm(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9 ]+/g,' ');}
  function tokens(s){return norm(s).split(/\s+/).filter(function(w){return w.length>=4;}).map(function(w){return w.length>4&&/s$/.test(w)?w.replace(/(es|s)$/,''):w;});}
  function personalize(sec){
    var interest;try{interest=JSON.parse(localStorage.getItem('zd_interest'))||{};}catch(e){interest={};}
    if(!Object.keys(interest).length)return;
    var list=rails(sec);if(!list.length)return;
    var items=[];list.forEach(function(r){items=items.concat(Array.prototype.slice.call(r.querySelectorAll('.zd-fp__item')));});
    var any=false;
    items.forEach(function(it,i){var s=0;tokens(it.dataset.keys).forEach(function(t){if(interest[t])s+=Number(interest[t])||0;});it._s=Math.min(s,20);it._i=i;if(s>0)any=true;});
    if(!any)return;
    var per=Math.ceil(items.length/list.length);
    items.sort(function(a,b){return (b._s-a._s)||(a._i-b._i);}).forEach(function(it,i){list[Math.min(list.length-1,Math.floor(i/per))].appendChild(it);});
  }
  function init(){
    document.querySelectorAll('.zd-offers-rail[data-zd-personal]').forEach(function(sec){if(sec.dataset.zdPers)return;sec.dataset.zdPers='1';personalize(sec);});
    document.querySelectorAll('.zd-offers-rail').forEach(function(sec){if(sec.dataset.zdReady)return;sec.dataset.zdReady='1';rails(sec).forEach(function(r){r.addEventListener('scroll',function(){sync(sec);},{passive:true});});window.addEventListener('resize',function(){sync(sec);});sync(sec);});
  }
  document.addEventListener('click',function(e){var btn=e.target.closest('.zd-offers-rail [data-zd-rail-dir]');if(!btn)return;var sec=btn.closest('.zd-offers-rail');rails(sec).forEach(function(rail){var item=rail.querySelector('.zd-fp__item');var step=item?item.getBoundingClientRect().width+12:rail.clientWidth*.8;var per=Math.max(1,Math.floor((rail.clientWidth+12)/step));rail.scrollBy({left:step*per*Number(btn.dataset.zdRailDir),behavior:'smooth'});});});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-partners"] && !Shopify.designMode) return;
  try {
    
function zdPreparePartners(root) {
  root.querySelectorAll('.zd-partners:not([data-initialized])').forEach(function(section) {
    section.dataset.initialized = 'true';
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        section.toggleAttribute('data-visible', entry.isIntersecting);
        if (!entry.isIntersecting || section.hasAttribute('data-loading')) return;
        section.dataset.loading = 'true';
        const images = Array.from(section.querySelectorAll('img'));
        images.forEach(function(img) { img.loading = 'eager'; });
        Promise.all(images.map(function(img) { return img.decode().catch(function() {}); })).then(function() { section.dataset.ready = 'true'; });
      });
    }, { rootMargin: '300px' });
    observer.observe(section);
  });
}
zdPreparePartners(document);
document.addEventListener('shopify:section:load', function() { zdPreparePartners(document); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zonlidoog-blog"] && !Shopify.designMode) return;
  try {
    
(function(){
  function sync(row){var rail=row.querySelector('.zd-home-picks__rail');if(!rail)return;var p=row.querySelector('[data-zd-journal-dir="-1"]');var n=row.querySelector('[data-zd-journal-dir="1"]');if(p)p.disabled=rail.scrollLeft<=4;if(n)n.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-4;}
  function init(){document.querySelectorAll('.zd-journal__row').forEach(function(row){if(row.dataset.zdReady)return;row.dataset.zdReady='1';var rail=row.querySelector('.zd-home-picks__rail');if(!rail)return;rail.addEventListener('scroll',function(){sync(row);},{passive:true});window.addEventListener('resize',function(){sync(row);});sync(row);});}
  document.addEventListener('click',function(e){var btn=e.target.closest('[data-zd-journal-dir]');if(!btn)return;var row=btn.closest('.zd-journal__row');var rail=row&&row.querySelector('.zd-home-picks__rail');if(!rail)return;var item=rail.firstElementChild;var step=item?item.getBoundingClientRect().width+12:rail.clientWidth*.8;var per=Math.max(1,Math.floor((rail.clientWidth+12)/step));rail.scrollBy({left:step*per*Number(btn.dataset.zdJournalDir),behavior:'smooth'});});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zonlidoog-confianza"] && !Shopify.designMode) return;
  try {
    
if (!window.zonlidoogPrivacyLinkReady) {
  window.zonlidoogPrivacyLinkReady = true;
  const localizePrivacyClose = () => {
    const close = document.querySelector('#shopify-pc__prefs__header-close');
    const trustSection = document.getElementById('zonlidoog-confianza');
    const closeLabel = trustSection && trustSection.dataset.cookieClose;
    if (close && closeLabel && close.getAttribute('aria-label') !== closeLabel) close.setAttribute('aria-label', closeLabel);
  };
  const privacyObserver = new MutationObserver(localizePrivacyClose);
  privacyObserver.observe(document.body, { childList: true, subtree: true });
  localizePrivacyClose();
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-z-cookie-preferences]');
    if (!link) return;
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    const status = link.parentElement.querySelector('[data-z-cookie-status]');
    try {
      if (status) status.hidden = true;
      await window.privacyBanner.showPreferences();
    } catch (error) {
      if (status) status.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zonlidoog-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zonlidoog-hero')) {
    customElements.define('zonlidoog-hero', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.zd-hero-motion');
        this.video = this.querySelector('video');
        if (this.dataset.motion !== 'true' && !this.video) return;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motionQuery.matches;
        this.inView = true;
        this.controller = new AbortController();
        this.dataset.animated = String(this.dataset.motion === 'true' && !this.motionQuery.matches);
        const options = { signal: this.controller.signal };
        this.sync = () => {
          const paused = this.userPaused || !this.inView || document.hidden;
          this.dataset.paused = String(paused);
          if (this.button) {
            this.button.setAttribute('aria-pressed', String(this.userPaused));
            this.button.querySelector('span').textContent = this.userPaused ? this.dataset.play : this.dataset.pause;
          }
          if (this.video) {
            if (paused) this.video.pause();
            else this.video.play().catch(() => { this.userPaused = true; this.dataset.paused = 'true'; if (this.button) { this.button.setAttribute('aria-pressed','true'); this.button.querySelector('span').textContent = this.dataset.play; } });
          }
        };
        if (this.button) {
          this.button.hidden = this.motionQuery.matches && !this.video;
          this.button.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, options);
        }
        this.motionQuery.addEventListener('change', () => {
          this.userPaused = this.motionQuery.matches;
          this.dataset.animated = String(this.dataset.motion === 'true' && !this.motionQuery.matches);
          if (this.button) this.button.hidden = this.motionQuery.matches && !this.video;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', this.sync, options);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold:0.08 });
        this.observer.observe(this);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zonlidoog-insurance"]) return;
  try {
    
  if (!customElements.get('zd-insurance-code')) {
    customElements.define('zd-insurance-code', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        const button = this.querySelector('button');
        const code = this.querySelector('strong');
        const status = this.querySelector('[role="status"]');
        if (!button || !code || !status || !navigator.clipboard?.writeText) return;
        this.dataset.ready = 'true';
        button.hidden = false;
        button.addEventListener('click', async () => {
          button.disabled = true;
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            status.textContent = this.dataset.success;
          } catch {
            status.textContent = this.dataset.failure;
          } finally {
            button.disabled = false;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
